import { isPresent } from 'utils/isPresent';
import { createBrowserHistory } from "history"
import AddJobApi from "../api/AddJobApi"
import { showErrorDialog } from "../../../Common/CommonActions.js"
import { SUCCESS_TEXT } from "../../../Common/SuccessDialog.jsx"
import {
    addTagInCache,
    deleteTagInCache,
    shouldAddTag,
    JOB_TYPE,
    UPDATE_TAGS_IN_PROGRESS
} from "../../../Tags/TagsData"
import RedirectTo from '../../../Common/RedirectTo'
import { trackEstimateCreatedFromNavBar } from "../../../Services/Analytics/TrackEventsService";
import { isVirtualEstimate } from "./Data"
import Utils from "../../../Common/Utils"
import { isBlank } from "utils/isBlank"

export const SERVICES = 'SERVICES'
export const MATERIALS = 'MATERIALS'
export const SET_STEP_INDEX = 'SET_STEP_INDEX'
export const SHOW_SPINNER = 'SHOW_SPINNER'
export const SHOW_CUSTOMER_LIST_SPINNER = 'SHOW_CUSTOMER_LIST_SPINNER'
export const UPDATE_CUSTOMER_FOR_JOB = 'UPDATE_CUSTOMER_FOR_JOB'
export const UPDATE_ADDRESS_FOR_JOB = 'UPDATE_ADDRESS_FOR_JOB'
export const UPDATE_PRIVATE_NOTES = 'UPDATE_PRIVATE_NOTES'
export const UPDATE_JOB_TAGS = 'UPDATE_JOB_TAGS'
export const STORE_SCHEDULE_INFO = 'STORE_SCHEDULE_INFO'
export const UPDATE_NEW_JOB_LINE_ITEMS = 'UPDATE_NEW_JOB_LINE_ITEMS'
export const UPDATE_NEW_JOB_TAX_INFO = 'UPDATE_NEW_JOB_TAX_INFO'
export const UPDATE_NEW_JOB_ATTACHMENTS_INFO = 'UPDATE_NEW_JOB_ATTACHMENTS_INFO'
export const SHOW_RECURRENCE_DIALOG = 'SHOW_RECURRENCE_DIALOG'
export const SET_RECURRENCE_BILLING_RULE = 'SET_RECURRENCE_BILLING_RULE'
export const SHOW_SEARCH_BOX_SPINNER = 'SHOW_SEARCH_BOX_SPINNER';

export const CUSTOMER_STEP_INDEX = 0
export const LINE_ITEMS_STEP_INDEX = 1
export const SCHEDULE_STEP_INDEX = 2
export const REVIEW_RECURRENCE_STEP_INDEX = 3
export const REVIEW_STEP_INDEX = 4

export const TOGGLE_IS_DISABLED = 'TOGGLE_IS_DISABLED'

export let browserHistory

export function initializeBrowserHistory(isEstimate) {
  browserHistory = createBrowserHistory({ basename: isEstimate ? '/pro/estimates/new' : '/pro/jobs/new' })
}

export function showSpinner(value) {
    return { type: SHOW_SPINNER, show: value }
}

function isValidLineItem(lineItem) {
    return isPresent(lineItem.name) ||
        isPresent(lineItem.description) ||
        lineItem.quantity !== 1 ||
        lineItem.unit_price !== 0
}

function formatLineItem(item, taxable, lineItems) {
    if (isValidLineItem(item)) {
        item.taxable = taxable
        item.unit_price = item.unit_price / 100
        lineItems.push(item)
    }
}

export function lineItemsArray(lineItems) {
    let line_items = []

    lineItems.labor_line_items.forEach((line_item) => {
        formatLineItem(line_item, line_item.taxable || false, line_items)
    })

    lineItems.material_line_items.forEach((line_item) => {
        formatLineItem(line_item, line_item.taxable || false, line_items)
    })

    lineItems.fixed_discount_line_items.forEach((line_item) => {
        formatLineItem(line_item, line_item.taxable || false, line_items)
    })

    lineItems.percent_discount_line_items.forEach((line_item) => {
        formatLineItem(line_item, line_item.taxable || false, line_items)
    })

    return line_items
}

function addJob() {
    return (dispatch, getState) => {
        let state = getState()
        let addressId = (state.serviceAddress || {}).service_address_id
        let addressHash = {}
        if (isPresent(state.serviceAddress) && isBlank(addressId)) {
            addressHash = {
                address_street: state.serviceAddress.street,
                address_street_line_2: state.serviceAddress.street_line_2,
                address_city: state.serviceAddress.city,
                address_state: state.serviceAddress.state,
                address_zip: state.serviceAddress.zip || state.serviceAddress.postal_code
            }
        }

        var data = {
            customer_id: (state.customer || {}).customer_id,
            address_id: addressId,
            notes: state.notes,
            request_tags: state.requestTags,
            line_items: lineItemsArray(state.lineItems),
            tax: state.taxInfo,
            notify_customer: state.scheduleInfo.notification_enabled['job_scheduled'],
            scheduled_start_time: state.scheduleInfo.start_time,
            scheduled_end_time: state.scheduleInfo.end_time,
            pro_ids: state.scheduleInfo.assigned_pro_ids,
            arrival_window_minutes: state.scheduleInfo.arrival_window_minutes,
            set_arrival_window_as_default: state.scheduleInfo.set_arrival_window_as_default,
            recurrence_billing_rule: state.recurrenceBillingRule,
            ...addressHash,
            is_virtual: isVirtualEstimate(state)
        }

        if (isPresent(state.scheduleInfo.recurrence_rule)) {
            data['recurrence_rule'] = state.scheduleInfo.recurrence_rule
            data['is_infinite_recurrence'] = state.scheduleInfo.is_infinite_recurrence
            return AddJobApi.addRecurringJob(data)
        } else if (state.isEstimate) {
            return AddJobApi.addOneTimeJob(data, 'estimate')
        } else {
            return AddJobApi.addOneTimeJob(data, 'job')
        }

    }

}

function addAttachments(jobId, uuid) {
    return (dispatch, getState) => {
        let state = getState()
        let allAttachmentsInfo = state.attachments

        if (isPresent(allAttachmentsInfo)) {
            let formData = new FormData()
            formData.append('request_id', jobId)
            formData.append('employee_id', state.scheduleInfo.assigned_pro_ids[0])

            allAttachmentsInfo.forEach((attachment, index) => {
                formData.append('request_attachments[]', attachment.file)
            })

            AddJobApi.addAttachments(formData)
                .catch((error) => {
                    dispatch({
                        type: SUCCESS_TEXT,
                        successText: error.response.data.error,
                        titleText: "Add attachments error"
                    })
                })
                .finally((() => {
                    successSaveJob(jobId, state.isEstimate)
                }))
        } else {
            successSaveJob(jobId, state.isEstimate)
        }
    }
}

export function saveNewJob() {
    return (dispatch, getState) => {
        dispatch({ type: TOGGLE_IS_DISABLED, status: true })
        dispatch(showSpinner(true))

        dispatch(addJob())
            .then((response) => {
              const id = response.data.job_id
              const isVirtual = isVirtualEstimate(getState())
              const uuid = response.data.uuid
              dispatch(trackEstimateCreatedFromNavBar(uuid, isVirtual))
                .finally(() => {
                  dispatch(addAttachments(id, uuid))
                })
            })
            .catch((error) => {
                dispatch({ type: TOGGLE_IS_DISABLED, status: false })
                dispatch(showSpinner(false))
                dispatch(showErrorDialog(Utils.parseErrorMessage(error)))
            })
    }
}

function successSaveJob(jobId, isEstimate) {
    if (isEstimate) {
        RedirectTo.estimate(jobId)
    } else {
        RedirectTo.job(jobId)
    }
}

export function fetchCustomer(customerId, ServiceAddressId) {
    return (dispatch, getState) => {
        dispatch({ type: SHOW_CUSTOMER_LIST_SPINNER, status: true })

          return AddJobApi.fetchCustomer(customerId, ServiceAddressId)
            .then(response => {
                let newCustomer = response.data.customer
                let newAddress = response.data.service_address
                if (isPresent(newCustomer)) {
                    dispatch({ type: UPDATE_CUSTOMER_FOR_JOB, customer: newCustomer })
                    dispatch({ type: UPDATE_ADDRESS_FOR_JOB, address: newAddress })

                    if (getState().scheduleInfo.notification_enabled['job_scheduled']) {
                        dispatch({
                            type: STORE_SCHEDULE_INFO, scheduleInfo: {
                                notification_enabled: {
                                    job_scheduled: newCustomer.notifications_enabled
                                }
                            }
                        })
                    }
                }
            })
            .catch(error => {
                dispatch(showErrorDialog(Utils.parseErrorMessage(error)))
            })
            .finally(() => {
                dispatch({ type: SHOW_CUSTOMER_LIST_SPINNER, status: false })
            })
    }
}

export function addTag(tagType, tag) {
    return (dispatch, getState) => {
        if (tagType === JOB_TYPE) {
            let jobTags = addTagInCache(getState().requestTags, tag)
            dispatch({ type: UPDATE_JOB_TAGS, tags: jobTags })
        } else {
            let jobCustomer = getState().customer

            if (shouldAddTag(jobCustomer.customer_tags_details, tag)) {
                dispatch({ type: UPDATE_TAGS_IN_PROGRESS, tagType: tagType, status: true })

                AddJobApi.addCustomerTag(jobCustomer.customer_id, tag)
                    .then(response => {
                        dispatch({ type: UPDATE_CUSTOMER_FOR_JOB, customer: response.data.customer })
                    })
                    .catch(error => {
                        dispatch(showErrorDialog(Utils.parseErrorMessage(error)))
                    })
                    .finally(() => {
                        dispatch({ type: UPDATE_TAGS_IN_PROGRESS, status: false })
                    })
            }
        }
    }
}

export function deleteTag(tagType, tag) {
    return (dispatch, getState) => {
        if (tagType === JOB_TYPE) {
            let jobTags = deleteTagInCache(getState().requestTags, tag)
            dispatch({ type: UPDATE_JOB_TAGS, tags: jobTags })
        } else {
            if (isPresent(tag.name)) {
                dispatch({ type: UPDATE_TAGS_IN_PROGRESS, tagType: tagType, status: true })

                AddJobApi.deleteCustomerTag(getState().customer.customer_id, tag)
                    .then(response => {
                        dispatch({ type: UPDATE_CUSTOMER_FOR_JOB, customer: response.data.customer })
                    })
                    .catch(error => {
                        dispatch(showErrorDialog(Utils.parseErrorMessage(error)))
                    })
                    .finally(() => {
                        dispatch({ type: UPDATE_TAGS_IN_PROGRESS, status: false })
                    })
            }
        }
    }
}

function updateAttachments(attachments) {
    return dispatch => {
        dispatch({ type: UPDATE_NEW_JOB_ATTACHMENTS_INFO, attachments: attachments })
    }
}

export function addAttachment(file) {
    return (dispatch, getState) => {
        let attachments = getState().attachments
        let totalFiles = getState().attachments.length
        let fileInfo = {
            file: file,
            id: totalFiles,
            name: file.name,
            url: URL.createObjectURL(file),
            type: ''
        }

        if (file.name.match(/.(jpg|jpeg|png|gif)$/i)) {
            fileInfo['thumb_url'] = fileInfo.url
            fileInfo['type'] = 'image'
        } else if (file.name.match(/.(pdf)$/i)) {
            fileInfo['type'] = 'pdf'
        }

        dispatch(updateAttachments(attachments.concat([fileInfo])))
    }
}

export function deleteAttachment(attachmentId) {
    return (dispatch, getState) => {
        let attachments = getState().attachments

        dispatch(updateAttachments(attachments.filter((attachment) =>
            attachment.id !== attachmentId
        )))
    }
}

export function getAssignedPros(allPros, assignedProIds) {
    let assignedPros = []
    for (var i = 0; i < allPros.length; i++) {
        let currentPro = allPros[i]
        let isAssignedPro = assignedProIds.indexOf(currentPro.id) !== -1
        if (isAssignedPro) {
            assignedPros.push(currentPro)
        }
    }

    return assignedPros
}

export function updateCustomer(customer) {
    return (dispatch, getState) => {
        /** Temporary using the old customer detail protocol id
         * from create_or_update_customer.rb
         */
        dispatch(fetchCustomer(customer.id))

        /** TODO (After remove old add job):
         * BRING BACK THESE CODE WHEN CHANGE create_or_update_customer.rb SUCCESS CALLBACK TO USE
         * Pro::Customers::WebProtocol::CustomerProtocol
         */
        // dispatch({type: UPDATE_CUSTOMER_FOR_JOB, customer: customer});
        //
        // if (getState().scheduleInfo.notification_enabled['job_scheduled']) {
        //     dispatch({type: STORE_SCHEDULE_INFO, scheduleInfo: {
        //         notification_enabled: {
        //             job_scheduled: customer.notifications_enabled
        //         }
        //     }});
        // }
        // if (isPresent(customer.addresses)) {
        //     dispatch({type: UPDATE_ADDRESS_FOR_JOB, address: customer.addresses[0]})
        // } else {
        //     dispatch({type: UPDATE_ADDRESS_FOR_JOB, address: {}})
        // }
    }
}
